import React from 'react';

export const UserSvg = (props) => {

  const { width, height, color } = props;

  if (color) {
    return (
      <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 18C22.1421 18 25.5 14.6421 25.5 10.5C25.5 6.35786 22.1421 3 18 3C13.8579 3 10.5 6.35786 10.5 10.5C10.5 14.6421 13.8579 18 18 18Z" fill={color} />
        <path d="M18.0002 21.75C10.4852 21.75 4.36523 26.79 4.36523 33C4.36523 33.42 4.69523 33.75 5.11523 33.75H30.8852C31.3052 33.75 31.6352 33.42 31.6352 33C31.6352 26.79 25.5152 21.75 18.0002 21.75Z" fill={color} />
      </svg>
    )
  }

  return (
    <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 29 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M24 26.7993V24.2333C26 22.8853 28.08 20.4543 28.703 17.3373C28.889 17.4403 28.909 17.5073 29.116 17.5073C30.107 17.5073 30.825 16.2203 30.825 14.6343C30.825 13.0723 30.002 11.8073 29.031 11.7693C29.218 11.0953 29.324 10.1923 29.324 9.03434C29.324 5.16834 26 0.527344 18.541 0.527344C11.912 0.527344 7.764 5.16834 7.764 9.03434C7.764 10.1573 7.833 11.0773 7.952 11.7893C7.041 11.9263 6.323 13.1413 6.323 14.6343C6.323 16.2213 7.127 17.5073 8.119 17.5073C8.325 17.5073 8.144 17.4403 8.328 17.3373C8.952 20.4533 11 22.8853 13 24.2323V26.6463C8 27.2913 1 30.0833 1 32.8763V33.9373C1 35.0003 2.076 35.0003 3.137 35.0003H32.862C33.924 35.0003 35 35.0003 35 33.9383V32.8773C35 30.2623 29 27.6523 24 26.7993Z" fill="#226699" />
    </svg>
  )
}